import cls from 'classnames';
import IconChevronRightSmall from '@picsart/icons/IconChevronRightSmall';

import { IToolIcon, IBottomLink } from '../../../../../data/tools/types';
import { SingleToolAppIcon } from '../../../SingleToolAppIcon';

import useStyles from './styles';

export type NavBodyItem = {
  id: string;
  icon?: IToolIcon;
  hasSublinks: boolean;
  text: string;
  href?: string;
  iconRound?: boolean;
};

type NavBodyProps = {
  items: NavBodyItem[];
  goDownTo: (id: string) => (e: any) => void;
  iconFill?: string;
  iconBackground?: string;
  arrowColor: string;
  bottomLinks?: IBottomLink[];
  className?: string;
};

export function NavBody({
  items,
  goDownTo,
  iconFill,
  iconBackground,
  arrowColor,
  bottomLinks,
  className,
}: NavBodyProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, className)}>
      <ul className={classes.lines}>
        {items.map(({ id, text, icon, hasSublinks, href, iconRound }) => {
          const fill = icon && (icon.noColor ? 'none' : iconFill || icon.fill);
          const background = icon && (icon.noColor ? 'none' : iconBackground || icon.background);

          const children = (
            <>
              <div className={classes.textContainer}>
                {icon && (
                  <SingleToolAppIcon
                    icon={{
                      ...icon,
                      fill,
                      background,
                    }}
                    size="small"
                    isRound={iconRound}
                  />
                )}
                <span className={classes.text}>{text}</span>
              </div>

              {hasSublinks && <IconChevronRightSmall fill={arrowColor} width={24} height={24} />}
            </>
          );

          return hasSublinks ? (
            <li key={id} onClick={goDownTo(id)} className={classes.line}>
              {children}
            </li>
          ) : (
            <li key={id}>
              <a href={href} className={classes.line}>
                {children}
              </a>
            </li>
          );
        })}
      </ul>

      {bottomLinks && (
        <ul className={cls(classes.bottomLinks, 'NavBodyBottomLinks')}>
          {bottomLinks.map(({ text, href }, i) => (
            <li key={`${text}${i}`} className={classes.bottomLinkContainer}>
              <a href={href} className={classes.bottomLink}>
                {text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
